export type ContractStatus = 'upcoming' | 'active' | 'ended';

/** Derived from the contract period; start/end are calendar dates, so compare whole days. */
export function getContractStatus(startDate: string | Date, endDate: string | Date, now: Date = new Date()): ContractStatus {
  const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const today = startOfDay(now);
  if (today < startOfDay(new Date(startDate))) return 'upcoming';
  if (today > startOfDay(new Date(endDate))) return 'ended';
  return 'active';
}

export const CONTRACT_STATUS_LABEL: Record<ContractStatus, string> = {
  upcoming: 'Upcoming',
  active: 'Active',
  ended: 'Ended',
};
